import {
  isLocalDev,
  isImagitasDev,
  isImagitasTest,
  isImagitasPreprod,
  isUspsDev,
  isUspsCat,
  isUspsSit,
} from '@mgo/core/src/environment';
/* eslint-disable */

export const getGAKey = () => {
  const origin = window.location.href;
  switch (true) {
    case isLocalDev(origin):
    case isImagitasDev(origin):
    case isImagitasTest(origin):
    case isImagitasPreprod(origin):
    case isUspsDev(origin):
    case isUspsCat(origin):
    case isUspsSit(origin):
      console.log('Not Google Analytics');
      return '';

    default:
      return 'UA-96718247-1';
  }
}

export default function () {
  const GA_KEY = getGAKey();
  const s = document.createElement('script');
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_KEY}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_KEY);
  function gtag() {
    if (GA_KEY) {
      dataLayer.push(arguments);
    } else {
      console.log('GA', arguments);
    }
  };
}
